/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  fileURL: "https://mzone.xuranium.com/file",
  Url: "https://mzone.xuranium.com/graphql",
  production: true,
  defaultLanguage: 'en-US',
  supportedLanguages: [
    'en-US',
    'ar-EG',
  ],
};
